#import "./AssetFields.graphql"

mutation AddAssetSecret(
  $assetId: ID!
  $kind: AssetSecretKindEnum!
  $secretValue: String!
) {
  addAssetSecret(
    input: { assetId: $assetId, kind: $kind, secretValue: $secretValue }
  ) {
    asset {
      ...AssetFields
    }
  }
}
